import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@app/core/services/authentication/authentication.service';
import { environment } from '@env';
import { AuthenticationEndpoint } from '@app/core/services/authentication/enums/authentication.enums';
import { PublicAuthenticationService } from '@app/core/services/public/authentication/public-authentication.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
	const authenticationService: AuthenticationService = inject(AuthenticationService);
	const publicAuthenticationService: PublicAuthenticationService = inject(PublicAuthenticationService);

	// Add authorization header with jwt token if available, exclude requests to bucket, verify token and firms
	const isOpenApi: boolean = req.url.includes('open_api');
	const addBearerToken: boolean =
		authenticationService.token &&
		!isOpenApi &&
		!req.url.includes(environment.bucketBaseUrl) &&
		!req.url.includes(AuthenticationEndpoint.VerifyToken) &&
		!req.url.includes('core_shared/firms/');

	if (addBearerToken) {
		req = req.clone({
			setHeaders: { authorization: `Bearer ${authenticationService.token}` }
		});
	} else if (isOpenApi) {
		req = req.clone({
			setHeaders: {
				authorization: `AccessCode ${publicAuthenticationService.activeAccessCodeSubject.value}`,
				email: publicAuthenticationService.email
			}
		});
	}
	return next(req);
};
